var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 0.666687C3.94996 0.666687 0.666626 3.95002 0.666626 8.00002C0.666626 12.05 3.94996 15.3334 7.99996 15.3334C12.05 15.3334 15.3333 12.05 15.3333 8.00002C15.3333 3.95002 12.05 0.666687 7.99996 0.666687ZM8.66663 4.66669C8.66663 4.48988 8.59639 4.32031 8.47136 4.19528C8.34634 4.07026 8.17677 4.00002 7.99996 4.00002C7.82315 4.00002 7.65358 4.07026 7.52855 4.19528C7.40353 4.32031 7.33329 4.48988 7.33329 4.66669V8.66669C7.33329 8.8435 7.40353 9.01307 7.52855 9.13809C7.65358 9.26312 7.82315 9.33335 7.99996 9.33335C8.17677 9.33335 8.34634 9.26312 8.47136 9.13809C8.59639 9.01307 8.66663 8.8435 8.66663 8.66669V4.66669ZM8.66663 11C8.66663 10.8232 8.59639 10.6536 8.47136 10.5286C8.34634 10.4036 8.17677 10.3334 7.99996 10.3334C7.82315 10.3334 7.65358 10.4036 7.52855 10.5286C7.40353 10.6536 7.33329 10.8232 7.33329 11V11.3334C7.33329 11.5102 7.40353 11.6797 7.52855 11.8048C7.65358 11.9298 7.82315 12 7.99996 12C8.17677 12 8.34634 11.9298 8.47136 11.8048C8.59639 11.6797 8.66663 11.5102 8.66663 11.3334V11Z",
    fill: "#EB5054"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.691e6217a2b922dd3115921a6b1a6b7e.svg";
export { ForwardRef as ReactComponent };